import { Account, User } from 'app/core/models';
import { Project, ProjectTemplate } from '../../projects.types';
import { PanelDef } from '@shared/components/panels/panels.types';
import { CustomField } from 'app/shared/modules/custom-form/custom-form.types';
import { Document, FileResource } from 'app/shared/modules/folders/folders.types';

export interface Offer {
  bid_round: string;
  closing_date: any;
  closing_period: any;
  counter_amount: number;
  dd_expiration_date: any;
  dd_period: any;
  description?: string;
  documents?: Document[];
  earnest_money_amount: number;
  file_resources?: FileResource[];
  group_name: any;
  id?: number;
  offer_price?: number;
  offer_type?: string;
  sent_at?: string;
  token?: string;
  user?: User;
  user_id?: number;
  user_name?: string;
  workflow_state?: OfferWorkflowStateEnum;

  noteable_id?: number;
  notebable_type?: string;
  created_at?: string;
}

export enum OfferWorkflowStateEnum {
  ACCEPTED = 'accepted',
  DRAFT = 'draft',
  REJECTED = 'rejected',
  SUBMITTED = 'submitted',
}

export type FileInput = { files: FileList; value: string };
export type FileUploadEvent = { target: FileInput };

export interface BidRound {
  key: string;
  label: string;
}

export interface OffersDialogDefinition {
  fields: CustomField[];
}

export interface OffersDialogDataModel {
  project: Project;
  projectTemplate: ProjectTemplate<any>;
  panelDef: PanelDef<any>;
  options: any;
  offer?: Offer;
  account: Account;
}
